import './popupListaAllegati.scss';

import React, { useImperativeHandle, useRef, useState, useEffect } from "react";
import { LoadPanel, Button, Popup } from "devextreme-react";
import { PopupRef, Position } from "devextreme-react/popup";
import { useScreenSize } from "../../utils/media-query";
import useApiConfiguration from "../../apiConfig";
import { GiustificativiApi, LavoriApi, GiustificativiAllegatiResponseDTO } from "../../data";
import { PopupPdfViewer } from "..";
import { PopupPdfViewerHandle } from "../pdfViewer/popupPdfViewer";

export type PopupListaAllegatiHandle = {
    show: (idLavoro: number, idTipoRimborso: number, titolo: string) => void;
};

type State = {
    idLavoro: number,
    idTipoRimborso: number,
    titolo: string,
    visible: boolean
};

const PopupListaAllegati: React.ForwardRefRenderFunction<PopupListaAllegatiHandle> = (props, ref) => {
    const popupRef = useRef<PopupRef>(null);
    const pdfViewerRef = useRef<PopupPdfViewerHandle>(null);
    const apiConfig = useApiConfiguration();
    const { isSmall, isXSmall } = useScreenSize();

    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>({ idLavoro: 0, idTipoRimborso: 0, titolo: '', visible: false });
    const [dataSourceAllegati, setDataSourceAllegati] = useState<GiustificativiAllegatiResponseDTO[]>([]);

    function onHide() {
        setState({ idLavoro: 0, idTipoRimborso: 0, titolo: '', visible: false });
    };

    useImperativeHandle(ref, () => ({
        show(idLavoro: number, idTipoRimborso: number, titolo: string) {
            setLoading(true);

            setState({ idLavoro, idTipoRimborso, titolo, visible: true });
        }
    }));

    useEffect(() => {
        if (state.visible) {
            const api = new GiustificativiApi(apiConfig);

            api.getAllegatiByGiustificativo({
                giustificativiAllegatiRequestDTO: {
                    idLavoro: state.idLavoro,
                    idTipoRimborso: state.idTipoRimborso
                }
            }).then((res) => {
                setDataSourceAllegati(res);
            }).finally(() => setLoading(false));
        }
    }, [state.visible, state.idLavoro, state.idTipoRimborso]);

    const showAllegato = async (idAllegato: number) => {
        setLoading(true);

        var api = new LavoriApi(apiConfig);
        const response = await api.getFileSpesaById({ idFileAllegato: idAllegato });
        if (response?.base64) {
            const fileContent = atob(response.base64);
            const byteArray = new Uint8Array(fileContent.length);
            for (let i = 0; i < fileContent.length; i++)
                byteArray[i] = fileContent.charCodeAt(i);

            const mimeType = "application.pdf";
            const fileBlob = new Blob([byteArray], { type: mimeType });

            if (fileBlob)
                pdfViewerRef.current?.show(fileBlob);
        }

        setLoading(false);
    };

    return (
        <React.Fragment>
            <Popup
                visible={state.visible} fullScreen={(isSmall || isXSmall)}
                dragEnabled={false} hideOnOutsideClick={false}
                showCloseButton showTitle ref={popupRef} title="Allegati"
                container=".dx-viewport" width={400} height={350} onHidden={onHide}
            >
                {loading && <LoadPanel style={{ zIndex: 9999 }} position={"center"} visible shading shadingColor="rgba(0, 0, 0, 0.4)" />}

                <Position at="center" my="center" of="" collision="fit" />

                <div className="divAllegatiGiustificativi">
                    <div className="file-section">
                        <div className="file-section-caption">
                            {state.titolo}
                        </div>

                        <div className="file-list">
                            {
                                dataSourceAllegati.map((f, i) => (
                                    <div key={i} className="file-item">
                                        <Button icon="pdffile" hint="Apri file" stylingMode="text" onClick={() => showAllegato(f.idFileAllegato)} />
                                        <span>{f.fileName}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                <PopupPdfViewer ref={pdfViewerRef} />
            </Popup>
        </React.Fragment>
    );
};

export default React.forwardRef(PopupListaAllegati);